import React, { useState, useEffect } from 'react';
import { FormSpy } from 'react-final-form';
import { BREAKPOINTS } from 'constants';
import utils from '@ehi/global-marketing-interface/lib/utils';
import PropTypes from './FirstInvalidFieldSpyPropTypes';

const FirstInvalidFieldSpy = ({ breakpoint, form, formId }) => {
  const setFieldData = form?.mutators?.setFieldData;
  const [previousIndicatedField, setPreviousIndicatedField] = useState(null);

  const getOrderedFieldNames = (formElement) => {
    const collection = utils.get(formElement, 'elements') || [];
    return [...collection].filter((e) => e.name).map((e) => e.name);
  };

  const setIndicatedField = (formState) => {
    const { errors } = formState;
    const shouldFocusAndActivate = breakpoint !== BREAKPOINTS.SMALL;
    let indicatedField = null;
    // indicate the first invalid field
    const registeredFields = getOrderedFieldNames(document.getElementById(formId));
    const invalidFieldKeys = Object.keys(errors);

    registeredFields.forEach((key) => {
      if (!indicatedField && invalidFieldKeys.indexOf(key) !== -1) {
        //  We need the isGuided Prop here to trigger the guided error
        setFieldData(key, {
          isFocusedActive: shouldFocusAndActivate,
          isGuided: true,
        });
        indicatedField = key;
      } else {
        setFieldData(key, {
          isFocusedActive: false,
        });
      }
    });

    if (indicatedField && indicatedField !== previousIndicatedField) {
      setPreviousIndicatedField(indicatedField);
    }
  };

  const handleChange = (formState) => {
    setIndicatedField(formState);
  };

  useEffect(() => {
    const formState = form.getState();
    setIndicatedField(formState);
  }, []);

  // hack for handleChange to get called  before render, referred from here https://github.com/final-form/react-final-form/issues/809#issuecomment-808942373
  return (
    <FormSpy
      onChange={(formState) => setTimeout(() => handleChange(formState), 0)}
      subscription={{ errors: true, submitFailed: true }}
    />
  );
};

FirstInvalidFieldSpy.propTypes = PropTypes;

export default FirstInvalidFieldSpy;
